import React, { useEffect, useState } from "react";
import SchedulerDashboardHeader from "./SchedulerDashboardHeader";
import useStaffAvailabilityFilter from "hooks/useStaffAvailabilityFilter";
import OfficeSchedule from "./OfficeSchedule";
import useAgendaFilter from "hooks/useAgendaFilter";
import MySchedule from "./MySchedule";
import SchedularDashboardHeaderMobile from "./SchedularDashboardHeaderMobile";
import { setStorage } from "utils";
import constants from "../../../../constants";
import SchedulerModal from "./modals/SchedulerModal";

export default function SchedulerDashboard({
  currentDate,
  onDateChange,
  appliedAgendaTypes,
  appliedViewSettig,
  appliedOfficeFilters,
  isSidebarActive,
  staffAvailabilityViewSelectedFromDashBoard,
  setStaffAvailabilityViewSelectedFromDashBoard,
  userList,
  otherStaffId,
  isEnterpriseFilterActive,
  selectedOwnerId,
  isSchedulerFeatureEnabled,
  isMySchedule,
  setIsMySchedule
}) {
  const [showHideScheduler, setShowHideScheduler] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModalHandler = () => setIsModalOpen(false);

  const staffAvailFiltersData = useStaffAvailabilityFilter();
  const agendaFiltersData = useAgendaFilter();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 991);
  useEffect(() => {
    staffAvailFiltersData?.setApiOffices(appliedOfficeFilters);
    staffAvailFiltersData?.setApiEmps(otherStaffId?.map((res) => res.id) ?? []);
    agendaFiltersData?.setApiOffices(appliedOfficeFilters);
    staffAvailFiltersData?.setUsersList(userList);
  }, [appliedOfficeFilters, otherStaffId, userList]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 991);
    };
    setShowHideScheduler(true);
    setTimeout(() => {
      setShowHideScheduler(false);
    }, 100);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSchedule = (e) => {
    setIsMySchedule(e.target.checked);
    setStorage(constants.notes.cache.isMySchedule, e.target.checked);
  };

  return (
    <div className="h-100">
      {isMobile ? (
        <SchedularDashboardHeaderMobile
          handleSchedule={handleSchedule}
          isMySchedule={isMySchedule}
          staffAvailabilityViewSelectedFromDashBoard={
            staffAvailabilityViewSelectedFromDashBoard
          }
          handleAvailabilityViewSelectedFromDashBoard={
            setStaffAvailabilityViewSelectedFromDashBoard
          }
          currentDateFromDashBoard={currentDate}
          setCurrentDateFromDashBoard={onDateChange}
          isSidebarActive={isSidebarActive}
          setIsModalOpen={setIsModalOpen}
          isSchedulerFeatureEnabled={isSchedulerFeatureEnabled}
        />
      ) : (
        <SchedulerDashboardHeader
          handleSchedule={handleSchedule}
          isMySchedule={isMySchedule}
          staffAvailabilityViewSelectedFromDashBoard={
            staffAvailabilityViewSelectedFromDashBoard
          }
          handleAvailabilityViewSelectedFromDashBoard={
            setStaffAvailabilityViewSelectedFromDashBoard
          }
          currentDateFromDashBoard={currentDate}
          setCurrentDateFromDashBoard={onDateChange}
          isSidebarActive={isSidebarActive}
          setIsModalOpen={setIsModalOpen}
          isSchedulerFeatureEnabled={isSchedulerFeatureEnabled}
        />
      )}

      {showHideScheduler ? null : isMySchedule ? (
        <MySchedule
          agendaFiltersData={agendaFiltersData}
          staffAvailabilityViewSelectedFromDashBoard={
            staffAvailabilityViewSelectedFromDashBoard
          }
          currentDateFromDashBoard={currentDate}
          setCurrentDateFromDashBoard={onDateChange}
          appliedAgendaTypes={appliedAgendaTypes}
          appliedViewSettig={appliedViewSettig}
          appliedOfficeFilters={appliedOfficeFilters}
          isEnterpriseFilterActive={isEnterpriseFilterActive}
        />
      ) : (
        <OfficeSchedule
          staffAvailFiltersData={staffAvailFiltersData}
          staffAvailabilityViewSelectedFromDashBoard={
            staffAvailabilityViewSelectedFromDashBoard
          }
          currentDateFromDashBoard={currentDate}
          setCurrentDateFromDashBoard={onDateChange}
          appliedAgendaTypes={appliedAgendaTypes}
          appliedViewSettig={appliedViewSettig}
          appliedOfficeFilters={appliedOfficeFilters}
          isEnterpriseFilterActive={isEnterpriseFilterActive}
        />
      )}
      {isModalOpen && (
        <SchedulerModal
          isModalOpen={isModalOpen}
          selectedOwnerId={selectedOwnerId}
          setIsModalOpen={setIsModalOpen}
          closeModalHandler={closeModalHandler}
          onConfirm={(submittedOrCancel) => {
            setIsModalOpen(false);
            if (submittedOrCancel) {
              setShowHideScheduler(true);
              setTimeout(() => {
                setShowHideScheduler(false);
              }, 100);
            }
          }}
        />
      )}
    </div>
  );
}
